    //price slider start
    let filterInput =  document.querySelectorAll('.filter-list input');
    const clearFilter = document.querySelector('.clear_filter');
    const availableInp = document.querySelector('input.available');

    // Debounce function
    function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    function initDualRangeSlider(fromSlider, toSlider, fromTooltip, toTooltip, sliderContainer, isPriceSlider) {
        if (!fromSlider || !toSlider || !sliderContainer) return;
        const step = parseInt(fromSlider.step) || 1;
        const minValue = parseInt(fromSlider.min) || 0;
        const maxValue = parseInt(fromSlider.max) || 100;
        const range = maxValue - minValue;

        // Create visual elements
        const trackFill = document.createElement('div');
        trackFill.className = 'slider-track-fill';

        const fromThumb = document.createElement('div');
        fromThumb.className = 'custom-thumb from-thumb';

        const toThumb = document.createElement('div');
        toThumb.className = 'custom-thumb to-thumb';

        const sliderElement = sliderContainer.querySelector('.range-slider');
        sliderElement.appendChild(trackFill);
        sliderElement.appendChild(fromThumb);
        sliderElement.appendChild(toThumb);

        // Hide original inputs but keep them for form submission
        fromSlider.style.display = 'none';
        toSlider.style.display = 'none';

        // Validate and clamp values
        function clampValue(value, min, max) {
            return Math.max(min, Math.min(max, isNaN(value) ? min : value));
        }

        // Update positions and values
        function updateSliderValues(fromValue, toValue) {
            // Clamp and validate values
            fromValue = clampValue(fromValue, minValue, maxValue - step);
            toValue = clampValue(toValue, minValue + step, maxValue);

            // Ensure fromValue <= toValue - step
            if (fromValue > toValue - step) {
                if (activeThumb === fromThumb) {
                    fromValue = toValue - step;
                } else {
                    toValue = fromValue + step;
                }
            }

            // Update slider values
            fromSlider.value = fromValue;
            toSlider.value = toValue;

            // Calculate positions (0-100%)
            const fromPos = ((fromValue - minValue) / range) * 100;
            const toPos = ((toValue - minValue) / range) * 100;

            // Update DOM
            fromThumb.style.left = `${fromPos}%`;
            toThumb.style.left = `${toPos}%`;
            trackFill.style.left = `${fromPos}%`;
            trackFill.style.width = `${toPos - fromPos}%`;

            // Update tooltips (with NaN protection)
            fromTooltip.textContent = isPriceSlider ? `£${fromValue}` : fromValue;
            toTooltip.textContent = isPriceSlider ? `£${toValue}` : toValue;
        }

        // Track active thumb
        let activeThumb = null;

        // Handle thumb dragging
        function setupThumbDrag(thumb, isFrom) {
            let isDragging = false;
            let startX = 0;
            let startLeft = 0;

            thumb.addEventListener('mousedown', startDrag);
            thumb.addEventListener('touchstart', startDrag);

            function startDrag(e) {
                isDragging = true;
                activeThumb = thumb;
                thumb.style.zIndex = '4';

                const clientX = e.clientX || (e.touches && e.touches[0].clientX);
                startX = clientX;
                startLeft = parseFloat(thumb.style.left) || (isFrom ? 0 : 100);

                document.addEventListener('mousemove', moveHandler);
                document.addEventListener('touchmove', moveHandler, { passive: false });
                document.addEventListener('mouseup', stopDrag);
                document.addEventListener('touchend', stopDrag);

                e.preventDefault();
                e.stopPropagation();
            }

            function moveHandler(e) {
                if (!isDragging) return;

                const clientX = e.clientX || (e.touches && e.touches[0].clientX);
                const rect = sliderElement.getBoundingClientRect();
                const deltaX = clientX - startX;
                const percentageDelta = (deltaX / rect.width) * 100;

                let newPosition = startLeft + percentageDelta;
                newPosition = clampValue(newPosition, 0, 100);

                const value = Math.round(minValue + (newPosition / 100) * range);

                if (isFrom) {
                    updateSliderValues(value, parseInt(toSlider.value));
                    toSlider.dispatchEvent(new Event('input'));
                } else {
                    updateSliderValues(parseInt(fromSlider.value), value);
                    fromSlider.dispatchEvent(new Event('input'));
                }

                e.preventDefault();
            }

            function stopDrag() {
                isDragging = false;
                activeThumb = null;
                thumb.style.zIndex = '3';

                document.removeEventListener('mousemove', moveHandler);
                document.removeEventListener('touchmove', moveHandler);
                document.removeEventListener('mouseup', stopDrag);
                document.removeEventListener('touchend', stopDrag);
            }
        }

        // Handle track clicks
        sliderElement.addEventListener('click', (e) => {
            // Ignore thumb clicks
            if (e.target.classList.contains('custom-thumb') || activeThumb) {
                return;
            }

            const rect = sliderElement.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const clickPos = (clickX / rect.width) * 100;
            const clickValue = clampValue(
                Math.round(minValue + (clickPos / 100) * range),
                minValue,
                maxValue
            );

            const fromValue = parseInt(fromSlider.value);
            const toValue = parseInt(toSlider.value);

            // Determine which thumb to move
            if (Math.abs(clickValue - fromValue) < Math.abs(clickValue - toValue)) {
                // Move from thumb (ensure it doesn't violate min gap)
                updateSliderValues(
                    Math.min(clickValue, toValue - step),
                    toValue

                );
                toSlider.dispatchEvent(new Event('input'));
            } else {
                // Move to thumb (ensure it doesn't violate min gap)
                updateSliderValues(
                    fromValue,
                    Math.max(clickValue, fromValue + step)
                );
                fromSlider.dispatchEvent(new Event('input'));
            }
        });

        // Initialize drag for both thumbs
        setupThumbDrag(fromThumb, true);
        setupThumbDrag(toThumb, false);

        // Initialize positions with validation
        updateSliderValues(
            clampValue(parseInt(fromSlider.value), minValue, maxValue - step),
            clampValue(parseInt(toSlider.value), minValue + step, maxValue)
        );

        // Dispatch initial events
        // const event = new Event('input', { bubbles: true });
        // fromSlider.dispatchEvent(event);
        // toSlider.dispatchEvent(event);
    }

    // Initialize sliders
    document.addEventListener('DOMContentLoaded', function() {
        // Price slider
        initDualRangeSlider(
            document.getElementById('fromSlider'),
            document.getElementById('toSlider'),
            document.getElementById('fromSliderTooltip'),
            document.getElementById('toSliderTooltip'),
            document.querySelector('.range_price'),
            true
        );

        // Age slider
        initDualRangeSlider(
            document.getElementById('fromAgeSlider'),
            document.getElementById('toAgeSlider'),
            document.getElementById('fromAgeSliderTooltip'),
            document.getElementById('toAgeSliderTooltip'),
            document.querySelector('.range_age'),
            false
        );
    });

    //price slider end ----------------------

    // const COLOR_TRACK = "#C3C3C3";
    // const COLOR_RANGE = "#FF2A2A";

    // // Get the sliders and tooltips
    // const fromSlider = document.querySelector('#fromSlider');
    // const toSlider = document.querySelector('#toSlider');
    // const fromTooltip = document.querySelector('#fromSliderTooltip');
    // const toTooltip = document.querySelector('#toSliderTooltip');
    // const scale = document.getElementById('scale');

    // const fromAgeSlider = document.querySelector('#fromAgeSlider');
    // const toAgeSlider = document.querySelector('#toAgeSlider');
    // const fromAgeTooltip = document.querySelector('#fromAgeSliderTooltip');
    // const toAgeTooltip = document.querySelector('#toAgeSliderTooltip');
    // const age_scale = document.getElementById('age_scale');


    // // Get min and max values from the fromSlider element
    // const MIN = parseInt(fromSlider?.getAttribute('min')); // scale will start from min value (first range slider)
    // const MAX = parseInt(fromSlider?.getAttribute('max')); // scale will end at max value (first range slider)
    // const STEPS = parseInt(scale?.dataset.steps); // update the data-steps attribute value to change the scale points

    // const AGE_MIN = parseInt(fromAgeSlider?.getAttribute('age_min')); // scale will start from min value (first range slider)
    // const AGE_MAX = parseInt(toAgeSlider?.getAttribute('age_max')); // scale will end at max value (first range slider)
    // const AGE_STEPS = parseInt(age_scale?.dataset.steps); // update the data-steps attribute value to change the scale points

    // const debounce = (mainFunction, delay) => {
    //     let timer;
    //     return function (...args) {
    //         clearTimeout(timer);
    //         timer = setTimeout(() => {
    //             mainFunction(...args);
    //         }, delay);
    //     };
    // };

    // function controlFromSlider(fromSlider, toSlider, fromTooltip, toTooltip) {
    //     const [from, to] = getParsed(fromSlider, toSlider);
    //     fillSlider(fromSlider, toSlider, COLOR_TRACK, COLOR_RANGE, toSlider);
    //     if (from > to) {
    //         fromSlider.value = to;
    //     }
    //     setTooltip(fromSlider, fromTooltip, 'price');
    // }

    // function controlToSlider(fromSlider, toSlider, fromTooltip, toTooltip) {
    //     const [from, to] = getParsed(fromSlider, toSlider);
    //     fillSlider(fromSlider, toSlider, COLOR_TRACK, COLOR_RANGE, toSlider);
    //     setToggleAccessible(toSlider,'toSlider');
    //     if (from <= to) {
    //         toSlider.value = to;
    //     } else {
    //         toSlider.value = from;
    //     }
    //     setTooltip(toSlider, toTooltip, 'price');
    // }

    // function controlAgeFromSlider(fromAgeSlider, toAgeSlider, fromAgeTooltip, toAgeTooltip) {
    //     const [from, to] = getParsed(fromAgeSlider, toAgeSlider);
    //     fillSlider(fromAgeSlider, toAgeSlider, COLOR_TRACK, COLOR_RANGE, toAgeSlider);
    //     if (from > to) {
    //         fromAgeSlider.value = to;
    //     }
    //     setTooltip(fromAgeSlider, fromAgeTooltip, 'age');
    // }

    // function controlAgeToSlider(fromAgeSlider, toAgeSlider, fromAgeTooltip, toAgeTooltip) {
    //     const [from, to] = getParsed(fromAgeSlider, toAgeSlider);
    //     fillSlider(fromAgeSlider, toAgeSlider, COLOR_TRACK, COLOR_RANGE, toAgeSlider);
    //     setToggleAccessible(toAgeSlider, 'toAgeSlider');
    //     if (from <= to) {
    //         toAgeSlider.value = to;
    //     } else {
    //         toAgeSlider.value = from;
    //     }
    //     setTooltip(toAgeSlider, toAgeTooltip, 'age');
    // }

    // function getParsed(currentFrom, currentTo) {
    //     const from = parseInt(currentFrom.value, 10);
    //     const to = parseInt(currentTo.value, 10);
    //     return [from, to];
    // }

    // function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    //     const rangeDistance = to.max - to.min;
    //     const fromPosition = from.value - to.min;
    //     const toPosition = to.value - to.min;
    //     controlSlider.style.background = `linear-gradient(
    //     to right,
    //     ${sliderColor} 0%,
    //     ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
    //     ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
    //     ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%,
    //     ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%,
    //     ${sliderColor} 100%)`;
    // }

    // function setToggleAccessible(currentTarget, slider) {
    //     const toSlider = document.querySelector(`#${slider}`);
    //     if (Number(currentTarget.value) <= 0) {
    //         toSlider.style.zIndex = 2;
    //     } else {
    //         toSlider.style.zIndex = 0;
    //     }
    // }

    // function setTooltip(slider, tooltip, type = 'age') {
    //     const value = slider.value;
    //     if (type === 'age') {
    //         tooltip.textContent = `${value} Years`;
    //     } else {
    //         tooltip.textContent = `£${value}`;
    //     }
    //     const thumbPosition = (value - slider.min) / (slider.max - slider.min);
    //     const percent = thumbPosition * 100;
    //     const markerWidth = 20; // Width of the marker in pixels
    //     const offset = (((percent - 50) / 50) * markerWidth) / 2;
    //     tooltip.style.left = `calc(${percent}% - ${offset}px)`;
    // }

    // function createScale(min, max, step, type = 'age') {
    //     const range = max - min;
    //     const steps = range / step;
    //     for (let i = 0; i <= steps; i++) {
    //         const value = min + (i * step);
    //         const percent = (value - min) / range * 100;
    //         const marker = document.createElement('div');
    //         marker.style.left = `${percent}%`;
    //         if (type === 'age') {
    //             marker.textContent = `${value} Years`;
    //             age_scale.appendChild(marker);
    //         }
    //         else {
    //             marker.textContent = `£${value}`;
    //             scale.appendChild(marker);
    //         }
    //     }
    // }

    // Use debounce for the slider events
    // const debouncedFromSlider = debounce(() => controlFromSlider(fromSlider, toSlider, fromTooltip, toTooltip), 100);
    // const debouncedToSlider = debounce(() => controlToSlider(fromSlider, toSlider, fromTooltip, toTooltip), 100);

    // const debouncedAgeFromSlider = debounce(() => controlAgeFromSlider(fromAgeSlider, toAgeSlider, fromAgeTooltip, toAgeTooltip), 100);
    // const debouncedAgeToSlider = debounce(() => controlAgeToSlider(fromAgeSlider, toAgeSlider, fromAgeTooltip, toAgeTooltip), 100);

    // // events
    // fromSlider.oninput = debouncedFromSlider;
    // toSlider.oninput = debouncedToSlider;
    // fromAgeSlider.oninput = debouncedAgeFromSlider;
    // toAgeSlider.oninput = debouncedAgeToSlider;

    // // Initial load
    // fillSlider(fromSlider, toSlider, COLOR_TRACK, COLOR_RANGE, toSlider);
    // fillSlider(fromAgeSlider, toAgeSlider, COLOR_TRACK, COLOR_RANGE, toAgeSlider);
    // setToggleAccessible(toSlider, 'toSlider');
    // setToggleAccessible(toAgeSlider, 'toAgeSlider');
    // setTooltip(fromSlider, fromTooltip, 'price');
    // setTooltip(fromAgeSlider, fromAgeTooltip, 'age');
    // setTooltip(toSlider, toTooltip, 'price');
    // setTooltip(toAgeSlider, toAgeTooltip, 'age');
    // createScale(MIN, MAX, STEPS, 'price');
    // createScale(AGE_MIN, AGE_MAX, AGE_STEPS, 'age');

    //price slider end ----------------------

    const handleInput = (e) => {
        let inputName = e.target.name;

        if (e.target.classList.contains('service')) {
            services = getArrayInputValues(inputName);
        }

        if (e.target.classList.contains('price')) {
            let priceMin = document.querySelector('input[name="price_min"]')?.value ?? '';
            let priceMax = document.querySelector('input[name="price_max"]')?.value ?? '';
            prices = [priceMin, priceMax];
        }

        if (e.target.classList.contains('age')) {
            let ageMin = document.querySelector('input[name="age_min"]')?.value ?? '';
            let ageMax = document.querySelector('input[name="age_max"]')?.value ?? '';
            ages = [ageMin, ageMax];
        }
        if (e.target.classList.contains('bust')) {
            busts = getArrayInputValues(inputName);
        }
        if (e.target.classList.contains('dress')) {
            dresses = getArrayInputValues(inputName);
        }
        if (e.target.classList.contains('hair_colour')) {
            hair_colour = getArrayInputValues(inputName);
        }
        if (e.target.classList.contains('category')) {
            category = getArrayInputValues(inputName);
        }
        if (e.target.classList.contains('nationality')) {
            nationality = getArrayInputValues(inputName);
        }

        clearFilter.classList.remove('d-none');
        updateFilterButton();
        fetchStaffRecords(chosenCoordinates.lat,chosenCoordinates.lng);
    };

    availableInp && availableInp.addEventListener('change', (e) => {
        if (e.target.checked) {
            available = e.target.value;
        } else {
            available = '';
        }
        updateFilterButton();
        fetchStaffRecords(chosenCoordinates.lat,chosenCoordinates.lng);
    });


    const getArrayInputValues = (inputName) => {
        const inputElements = document.querySelectorAll(`input[name="${inputName}"]`);
        let filterval = [];
        inputElements.forEach(input => {
            if (input.checked) {
                if (!filterval.includes(input.value)) {
                    filterval.push(input.value);
                }
            } else {
                filterval = filterval.filter(value => value !== input.value);
            }
        });
        return filterval;
    }

    const debouncedInputHandler = debounce(handleInput, 500);

    filterInput.forEach(item => {
        item.addEventListener('input', debouncedInputHandler);
    });

    const addRemoveActiveOnclick = (ele) => {
        if(ele) {
            let targetEle = document.querySelector(ele),
            actinArray = targetEle.querySelectorAll('li'),
            clearBorough = targetEle.querySelector('.btn-clearBorough');
            let hasActive = false;
            //let clearBorough = document.querySelector(ele);
            actinArray.forEach(i => {
                i.addEventListener('click', (e)=> {
                    e.target.classList.toggle('active');
                    if(e.target.classList.contains('active')){
                        borough.push(i.dataset.slug);
                    }else{
                        borough = borough.filter(s => s !== i.dataset.slug);
                    }
                    // galleryRow.innerHTML = ``;
                    // start = 0;
                    // reachMax = false;
                    // docHeight = 0;
                    // //console.log(borough)
                    // getStaff();

                    hasActive = Array.from(actinArray).some(item => item.classList.contains('active'));
                    //console.log(hasActive);
                    hasActive?clearBorough.classList.remove('d-none'):clearBorough.classList.add('d-none');

                })
            })

            clearBorough.addEventListener('click', (e) => {
                actinArray.forEach(item => {
                    item.classList.contains('active')?item.classList.remove('active'):null;
                });
                setTimeout(()=>{e.target.classList.add('d-none')}, 100)
                galleryRow.innerHTML = ``;
                start = 0;
                reachMax = false;
                docHeight = 0;
                borough = [];
                //console.log(borough)
                getStaff();
            })
        }
    }

    clearFilter && clearFilter.addEventListener('click', () => {
        const checkInput = document.querySelectorAll(`input[type="checkbox"]`);
        checkInput.forEach(input => {
            if (input.checked) {
                input.checked = false;
            }
        });

        const srtOption = document.querySelectorAll(`input[type="radio"]`);
        srtOption.forEach(input => {
            input.checked = false;
        });

        // Reset price slider values
        const fromSlider = document.getElementById('fromSlider');
        const toSlider = document.getElementById('toSlider');

        // Temporarily remove event listeners to prevent duplicate AJAX calls
        let oldFromSliderClone = null;
        let oldToSliderClone = null;
        if (fromSlider && toSlider) {
            oldFromSliderClone = fromSlider.cloneNode(true);
            oldToSliderClone = toSlider.cloneNode(true);
            fromSlider.parentNode.replaceChild(oldFromSliderClone, fromSlider);
            toSlider.parentNode.replaceChild(oldToSliderClone, toSlider);
        }

        const priceMinInput = document.querySelector('input[name="price_min"]');
        const priceMaxInput = document.querySelector('input[name="price_max"]');
        if (priceMinInput && priceMaxInput) {
            priceMinInput.value = oldpricemin;
            priceMaxInput.value = oldpricemax;
            priceMinInput.setAttribute('min', oldpricemin);
            priceMinInput.setAttribute('max', oldpricemax);
            priceMaxInput.setAttribute('min', oldpricemin);
            priceMaxInput.setAttribute('max', oldpricemax);
        }
        // fillSlider(fromSlider, toSlider, COLOR_TRACK, COLOR_RANGE, toSlider);

        // Reset price slider visual representation
        if (oldFromSliderClone && oldToSliderClone) {
            const priceContainer = document.querySelector('.range_price');
            if (priceContainer) {
                const trackFill = priceContainer.querySelector('.slider-track-fill');
                const fromThumb = priceContainer.querySelector('.from-thumb');
                const toThumb = priceContainer.querySelector('.to-thumb');

                if (trackFill && fromThumb && toThumb) {
                    const range = parseInt(oldToSliderClone.max) - parseInt(oldFromSliderClone.min);
                    const fromPos = ((oldpricemin - parseInt(oldFromSliderClone.min)) / range) * 100;
                    const toPos = ((oldpricemax - parseInt(oldFromSliderClone.min)) / range) * 100;

                    fromThumb.style.left = `${fromPos}%`;
                    toThumb.style.left = `${toPos}%`;
                    trackFill.style.left = `${fromPos}%`;
                    trackFill.style.width = `${toPos - fromPos}%`;

                    const fromTooltip = document.getElementById('fromSliderTooltip');
                    const toTooltip = document.getElementById('toSliderTooltip');
                    if (fromTooltip && toTooltip) {
                        fromTooltip.textContent = `£${oldpricemin}`;
                        toTooltip.textContent = `£${oldpricemax}`;
                    }
                }
            }
        }

        // Reset age slider values
        const fromAgeSlider = document.getElementById('fromAgeSlider');
        const toAgeSlider = document.getElementById('toAgeSlider');

        // Temporarily remove event listeners to prevent duplicate AJAX calls
        let oldFromAgeSliderClone = null;
        let oldToAgeSliderClone = null;
        if (fromAgeSlider && toAgeSlider) {
            oldFromAgeSliderClone = fromAgeSlider.cloneNode(true);
            oldToAgeSliderClone = toAgeSlider.cloneNode(true);
            fromAgeSlider.parentNode.replaceChild(oldFromAgeSliderClone, fromAgeSlider);
            toAgeSlider.parentNode.replaceChild(oldToAgeSliderClone, toAgeSlider);
        }

        const ageMinInput = document.querySelector('input[name="age_min"]');
        const ageMaxInput = document.querySelector('input[name="age_max"]');
        if (ageMinInput && ageMaxInput) {
            ageMinInput.value = oldagemin;
            ageMaxInput.value = oldagemax;
            ageMinInput.setAttribute('min', oldagemin);
            ageMinInput.setAttribute('max', oldagemax);
            ageMaxInput.setAttribute('min', oldagemin);
            ageMaxInput.setAttribute('max', oldagemax);
        }
        // fillSlider(fromAgeSlider, toAgeSlider, COLOR_TRACK, COLOR_RANGE, toAgeSlider);

        // Reset age slider visual representation
        if (oldFromAgeSliderClone && oldToAgeSliderClone) {
            const ageContainer = document.querySelector('.range_age');
            if (ageContainer) {
                const ageTrackFill = ageContainer.querySelector('.slider-track-fill');
                const ageFromThumb = ageContainer.querySelector('.from-thumb');
                const ageToThumb = ageContainer.querySelector('.to-thumb');

                if (ageTrackFill && ageFromThumb && ageToThumb) {
                    const ageRange = parseInt(oldToAgeSliderClone.max) - parseInt(oldFromAgeSliderClone.min);
                    const ageFromPos = ((oldagemin - parseInt(oldFromAgeSliderClone.min)) / ageRange) * 100;
                    const ageToPos = ((oldagemax - parseInt(oldFromAgeSliderClone.min)) / ageRange) * 100;

                    ageFromThumb.style.left = `${ageFromPos}%`;
                    ageToThumb.style.left = `${ageToPos}%`;
                    ageTrackFill.style.left = `${ageFromPos}%`;
                    ageTrackFill.style.width = `${ageToPos - ageFromPos}%`;

                    const fromAgeTooltip = document.getElementById('fromAgeSliderTooltip');
                    const toAgeTooltip = document.getElementById('toAgeSliderTooltip');
                    if (fromAgeTooltip && toAgeTooltip) {
                        fromAgeTooltip.textContent = oldagemin;
                        toAgeTooltip.textContent = oldagemax;
                    }
                }
            }
        }

        document.querySelector('button[data-bs-dismiss="offcanvas"]').click();
        sort = '';
        prices = [];
        nationality = [];
        hair_colour = [];
        services = [];
        category = [];
        dresses = [];
        ages = [];
        available = '';
        clearAutoComplete();
        assignAutoComplete();
        updateFilterButton();
        // updateMapCenter(defaultCoordinates.lat,defaultCoordinates.lng);
        // Re-initialize sliders after a short delay to ensure proper event handling
        setTimeout(() => {
            // Price slider
            initDualRangeSlider(
                document.getElementById('fromSlider'),
                document.getElementById('toSlider'),
                document.getElementById('fromSliderTooltip'),
                document.getElementById('toSliderTooltip'),
                document.querySelector('.range_price'),
                true
            );

            // Age slider
            initDualRangeSlider(
                document.getElementById('fromAgeSlider'),
                document.getElementById('toAgeSlider'),
                document.getElementById('fromAgeSliderTooltip'),
                document.getElementById('toAgeSliderTooltip'),
                document.querySelector('.range_age'),
                false
            );
        }, 100);
    });

    const tcounter = document.querySelector('.t_count');
    tcounter && tcounter.addEventListener("click", function(e){
        if(tcounter.classList.contains('active')){
            const dismissBtn = document.querySelector('button[data-bs-dismiss="offcanvas"]');
            if (dismissBtn) dismissBtn.click();
        }
    });

    document.querySelectorAll(`input[name="sortby"]`).forEach((radio) => {
        radio.addEventListener("change", function (e) {

            sort = e.target.value;
            fetchStaffRecords(chosenCoordinates.lat,chosenCoordinates.lng);
        });
    });
